import { CONFIG as h } from "@packages/config";
import { Injectable as m, Inject as c } from "@webmotors/ioc";
import { LOCAL_STORAGE_SERVICE as v, COOKIE_SERVICE as S } from "@packages/common";
import { document as k } from "@packages/global";
import { COOKIE_CONSENTS_SERVICE as f } from "./main19.js";
import { CookieConsentsConfigDTO as l } from "./main85.js";
import { CookieConsentsDTO as p } from "./main86.js";
var u = Object.getOwnPropertyDescriptor, g = (e, o, t, r) => {
  for (var i = r > 1 ? void 0 : r ? u(o, t) : o, s = e.length - 1, n; s >= 0; s--)
    (n = e[s]) && (i = n(i) || i);
  return i;
}, a = (e, o) => (t, r) => o(t, r, e);
let C = class {
  constructor(e, o, t) {
    this.localStorageService = e, this.cookieService = o, this.config = t;
  }
  async save(e) {
    return this.localStorageService.setItem(this.config.cookieNoticeName, e), e;
  }
  async getCookieConsent() {
    const e = this.localStorageService.getItem(
      this.config.cookieNoticeName
    );
    return e || this.save(
      new l({
        showCookieNotice: !0,
        cookies: new p({
          proposals: !0,
          search: !0,
          marketing: !0,
          experience: !0
        })
      })
    );
  }
  clearSearchCookies() {
    const e = ["WMLastFilterSearch", "WebMotorsLastSearches"];
    for (const o of e)
      this.cookieService.removeCookie(o);
  }
  async saveCookieConsent(e) {
    const o = await this.save(e);
    return o.cookies.search || this.clearSearchCookies(), k.dispatchEvent(
      new CustomEvent("@CookieService:saveCookieConsent", {
        detail: o
      })
    ), o;
  }
  async isSearchEnabled() {
    const { cookies: e } = await this.getCookieConsent();
    return !!(e != null && e.search);
  }
};
C = g([
  m(f),
  a(0, c(v)),
  a(1, c(S)),
  a(2, c(h))
], C);
export {
  C as CookieConsentsService
};
